import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { BtwText, Stack } from '@marvelapp/ballpark-components';
import { StopwatchIcon } from '@marvelapp/ballpark-icons';
import { formatTime } from '@marvelapp/core';
export const DurationCell = observer(function DurationCell({ value, }) {
    return (_jsx(BtwText, { weight: "medium", children: _jsxs(Stack, { direction: "row", align: "center", gap: "2", children: [_jsx(StopwatchIcon, { className: "size-4" }), " ", formatTime(value)] }) }));
});
